<template>
  <div>
    <PageTitle
      title="Edit Document Upload"
      :backBtn="true"
      :showLoading="isLoading"
    />
    <v-container fluid class="lighten-12 container">
      <ValidationObserver ref="observer">
        <v-card>
          <v-card-title>General</v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="name"
                  name="Document name"
                  rules="required"
                >
                  <v-text-field
                    outlined
                    v-model="DocumentUploadList.name"
                    :error-messages="errors"
                    dense
                    hide-details="auto"
                    label="Name"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="DocumentType"
                  dense
                  rules="required"
                >
                  <v-autocomplete
                    v-model="DocumentUploadList.type_id"
                    item-text="name"
                    item-value="id"
                    :items="documentUploadType"
                    :error-messages="errors"
                    :loading="loadingDocumentType"
                    :search-input.sync="searchDocumentType"
                    outlined
                    required
                    dense
                    hide-details
                    label="Document Type"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider>
                  <datePickComponent
                    hide-details="auto"
                    v-model="DocumentUploadList.date"
                    labelname="Date"
                  />
                </ValidationProvider>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>Description</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-textarea
                      rows="3"
                      outlined
                      v-model="DocumentUploadList.description"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>Files</v-card-title>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <FileUpload
                      :multiple="true"
                      size="2048"
                      icon="mdi-upload"
                      autoupload="true"
                      :url="
                        'document/upload/DOCUMENTUPLOAD/' +
                        this.$route.params.id
                      "
                      :showDocumentView="true"
                      :documentsUrl="
                        'document/DOCUMENTUPLOAD/' + this.$route.params.id
                      "
                      downloadUrl="document/:id/download"
                      removeUrl="document/:id"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn depressed small class="text-white btn_medium" @click="clear"
            >Clear</v-btn
          >

          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="submit"
            >Update</v-btn
          >
        </v-card-actions>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import datePickComponent from '../../../components/base/DateComponent';
import { DocumentUploadType } from '../../../models/DocumentUploadType';
import { required, email, max, numeric } from 'vee-validate/dist/rules';
import { mapState } from 'vuex';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
  withValidation,
} from 'vee-validate';
import _ from 'lodash';

import * as moment from 'moment/moment';
import FileUpload from '@/components/base/FileUpload';
import store from '../../../store/store';
import axios from '@/plugins/axios';
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('numeric', {
  ...numeric,
  message: 'input must be numeric',
});
export default {
  data: () => ({
    selectedFiles: '',
    messages: [],
    DocumentUploadList: {},
    errors: [],
    selectedDocumentUploads: [],
    documentUploadTypes: [new DocumentUploadType()],
    searchDocumentType: null,
    loadingDocumentType: false,
    isLoading: false,
  }),
  props: {
    documentUploadType: [],
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
    FileUpload,
  },
  computed: {
    ...mapState(['productpagesize']),
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.EditDocumentUpload();
      }
    },

    GetDocumentUpload() {
      let Id = this.$route.params.id;
      axios
        .get(`document-uploads/${Id}`)
        .then((resp) => {
          this.DocumentUploadList = resp.data;
          this.DocumentUploadList.date = moment().format('YYYY-MM-DD');
        })
        .catch((err) => {
          reject(err.response);
        });
    },

    EditDocumentUpload() {
      this.isLoading = true;
      let credentials = this.DocumentUploadList;
      credentials.Id = this.$route.params.id;

      this.$store
        .dispatch('DocumentUpload/EditDocumentUpload', credentials)
        .then((res) => {
          if (this.selectedFiles) {
            var fileId = this.$route.params.id;
            var files = this.selectedFiles;
            var documentType = 'DOCUMENTUPLOAD';
            this.$store
              .dispatch('DocumentUploads', {
                fileId,
                files,
                documentType,
              })
              .then((resp) => {});
          }
          this.$toast.success('Document updated successfully.');
          this.isLoading = false;
          this.$router.push('?page=' + this.productpagesize);
          this.$router.push(`/document-uploads`);
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data;
        });
    },

    GetDocumentUploadTypes() {
      axios
        .get('document-types')
        .then((res) => {
          this.documentUploadType = res.data.data;
          this.loadingDocumentType = false;
        })
        .catch((err) => {
          this.loadingDocumentType = false;
          this.messages.push(err.data.title);
        });
    },
    GetDocumentTypesByQuery(query = '') {
      this.loadingDocumentType = true;
      this.$store
        .dispatch('document-upload/GetDocumentTypeSearch', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.documentUploadType = new DocumentUploadType().MapData(res.data);
          this.loadingDocumentType = false;
        })
        .catch((err) => {});
    },

    clear() {
      this.isDocumentUploadListValid = '';
      this.$refs.fileUpload.removeAllItems();
      this.selectedDocumentUploads = [];

      this.$refs.fileUpload.this.$refs.observer.reset();
    },
  },

  created() {
    this.GetDocumentUploadTypes();
    this.GetDocumentUpload();
  },
};
</script>
